import { Moon, Sun } from 'lucide-react';
import { useAppContext } from '../contexts/AppContext';

type ThemeToggleProps = {
    withLabel?: boolean;
    className?: string;
    labelClassName?: string;
};

export const ThemeToggle = ({ withLabel = false, className = '', labelClassName = '' }: ThemeToggleProps) => {
    const { theme, toggleTheme } = useAppContext();
    const isDark = theme === 'dark';
    const resolvedClassName = className || (withLabel ? 'sf-menu-item w-full rounded-2xl px-3.5 py-3 text-sm font-semibold' : 'sf-icon-button btn btn-circle btn-sm');

    return (
        <button
            type="button"
            onClick={toggleTheme}
            className={resolvedClassName}
            aria-label={isDark ? 'Ativar modo claro' : 'Ativar modo escuro'}
            aria-pressed={isDark}
            title={isDark ? 'Modo claro' : 'Modo escuro'}
        >
            {isDark ? <Sun className="sf-menu-item-icon" aria-hidden="true" /> : <Moon className="sf-menu-item-icon" aria-hidden="true" />}
            {withLabel && (
                <span className={`min-w-0 flex-1 truncate ${labelClassName}`}>{isDark ? 'Modo claro' : 'Modo escuro'}</span>
            )}
        </button>
    );
};
